import React from "react";
import {
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";
import { Owner } from "./BuildingEditPage";
import { formatDate } from "../../../common/const";

interface BuildingEditOwnerDetailsProps {
  selectedOwner: Owner | undefined;
  buildingOwner: Owner | undefined;
}

export const BuildingEditOwnerDetails: React.FC<
  BuildingEditOwnerDetailsProps
> = ({ selectedOwner, buildingOwner }) => {
  const displayDate = () => {
    if (selectedOwner?.createdAt) {
      return formatDate(selectedOwner.createdAt);
    }
    if (buildingOwner?.createdAt) {
      return formatDate(buildingOwner.createdAt);
    }
    return "";
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row" colSpan={2}>
              <Typography variant="h6">LAD契約者（オーナー）情報</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>
              {selectedOwner?.ownerId || buildingOwner?.ownerId}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>パスワード</TableCell>
            <TableCell>
              {selectedOwner?.password || buildingOwner?.password}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>契約者番号</TableCell>
            <TableCell>
              {selectedOwner?.subscribeNumber || buildingOwner?.subscribeNumber}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>名称(氏名)</TableCell>
            <TableCell>
              {selectedOwner?.ownerName || buildingOwner?.ownerName}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>会社名(部署名)</TableCell>
            <TableCell>
              {selectedOwner?.departmentName || buildingOwner?.departmentName}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>代表者名</TableCell>
            <TableCell>
              {selectedOwner?.representativeName ||
                buildingOwner?.representativeName}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>担当者名</TableCell>
            <TableCell>
              {selectedOwner?.picName || buildingOwner?.picName}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>連絡先(TEL)</TableCell>
            <TableCell>
              {selectedOwner?.ownerPhone || buildingOwner?.ownerPhone}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>連絡先(mail)</TableCell>
            <TableCell>
              {selectedOwner?.ownerEmail || buildingOwner?.ownerEmail}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>登録日</TableCell>
            <TableCell>{displayDate()}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>メモ</TableCell>
            <TableCell>{selectedOwner?.memo || buildingOwner?.memo}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>有効/無効</TableCell>
            <TableCell>
              {selectedOwner?.isEnabled === undefined ||
              selectedOwner?.isEnabled === null
                ? buildingOwner?.isEnabled
                  ? "有効"
                  : "無効"
                : selectedOwner?.isEnabled
                ? "有効"
                : "無効"}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
